// extracted by mini-css-extract-plugin
module.exports = {"btn":"SubmitButton_btn__6lIsJ","teal":"SubmitButton_teal__2j5Dt"};